import { lazy } from "react";

const Travel = lazy(() => import("../../../Common/Travel/Travel"));
const RestartSimTracking = lazy(() => import("../../../Common/Travel/restartSimTracking"));
const ShowTravelData = lazy(() => import("../../../Common/Travel/ShowTravelData"));
const Feedback = lazy(() => import("../../../Common/Feedback/Feedback"));
const ShowFullFeedback = lazy(() => import("../../../Common/Feedback/ShowFullFeedback"));
const Holiday = lazy(() => import("../../../../Pages/Holiday/Holiday"));
const AddUpdateHoliday = lazy(() => import("../../../../Pages/Holiday/AddUpdateHoliday"));

export const TravelRoute = [
    { path: "travel", element: <Travel key="travel" /> },
    { path: "restart-sim-track", element: <RestartSimTracking /> },
    { path: "travelExtend", element: <Travel key="travelExtend" /> },
    { path: "showTravel", element: <ShowTravelData /> },
    { path: "showTravelExtend", element: <ShowTravelData /> },
    { path: "feedback", element: <Feedback /> },
    { path: "ShoweFeedBack", element: <ShowFullFeedback /> },
    { path: "Holiday", element: <Holiday /> },
    { path: "addUpdateHoliday", element: <AddUpdateHoliday /> },
];

